<!--
* UIID: UI-DLB-MAP-140
* UI Name: Mapper Check In
* Modify Date: 2021/01/18
-->
<template>
  <dialog-drag
    :id="id"
    :ref='"dialog-" + id'
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-add-map-layout-dialog"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title
        class="headline white--text"
        primary-title>
        {{$t('lbl.mapManager.mapperVersionHistory.mapperCheckIn.header')}}
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon>
    </template>
    <!-- [E]  Popup title-->

    <v-card class="dialog-container">

      <!-- [S]  Popup body-->
      <v-card-text class="pb-0">
        <!-- 203705_MapManager_Fix issues_9 -->
        <v-form ref="form" class="dialog-content">
          <v-row class="ml-0 mr-0">
            <v-col class="not-required-col field-col pt-0" lg="2">
              <span class="field-label required-text">
                {{$t('lbl.mapManager.mapperVersionHistory.mapperCheckIn.mapName')}}
              </span>
            </v-col>
            <v-col class="map-text-field inline-block-component pt-0 pl-0" lg="10">
              <v-text-field
                v-model="mapName"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout flatfile-textfield scanner-textfield"
                heigth="30"
                outlined
                hide-details
                dense
                solo
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col lg="12" class="customer-add-map-layout">
             <div class="layout-chkin-color_u">
                <a @click="openCodeTableDialog">{{selectCodeName}}</a>
              </div>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col" lg="2">
              <v-icon  x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{$t('lbl.mapManager.mapperVersionHistory.mapperCheckIn.mapperName')}}
              </span>
            </v-col>
            <v-col class="map-text-field inline-block-component pl-0" :lg="isDlb ? 7 : 10">
              <v-text-field
                  v-model="contenInput"
                  :class="['data-table-filter-text-field text-field-flatfile-layout flatfile-textfield scanner-textfield', isValidU ? 'focusField' : '']"
                  heigth="30"
                  outlined
                  hide-details
                  dense
                  solo
                  readonly
                >
                </v-text-field>
                <input
                  @change="onFileChanged"
                  id="edifile"
                  type="file"
                  ref="edifile"
                  style="display: none"
                >
                 <v-btn :class="['btn btn-search scanner-load-btn', isDlb ? 'mr-3' : '']" color="primary" @click="openLoadFilePop({mode: 'Load', filetype: 'mapper'})">
                  {{$t('btn.mapManager.load')}}
                </v-btn>
            </v-col>
            <v-col v-if="isDlb" lg="3" class="map-text-field pr-0 pl-0">
              <v-select
                  v-model="libraryVersion"
                  :items="libraryItem"
                  @change="onVersionChange(libraryVersion)"
                  class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box"
                  ref="refMapTypeTo"
                  height="30"
                  dense
                  solo
                  outlined
                >
              </v-select>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col pb-0" lg="2">
              <v-icon  x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{$t('lbl.mapManager.mapperVersionHistory.mapperCheckIn.comment')}}
              </span>
            </v-col>
            <v-col class="map-text-field inline-block-component pb-0 pl-0" lg="10">
              <v-text-field
                  v-model="contentComment"
                  :class="['data-table-filter-text-field text-field-flatfile-layout flatfile-textfield scanner-textfield', isValidC ? 'focusField' : '']"
                  heigth="30"
                  ref="comRef"
                  outlined
                  hide-details
                  dense
                  solo
                >
                </v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-search" color="primary" @click="saveCheckIn()">
                <v-icon x-small class="mr-2">fas fa-save</v-icon>{{$t('btn.common.save')}}
              </v-btn>
              <v-btn class="btn btn-delete" @click="removeDialog">
                <v-icon small color="white" class="mr-1">fa fa-times</v-icon>{{$t('btn.common.cancel')}}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <dialogWindow
      ref="successDialog"
      size="max"
      title="Success"
      :detail="$t('msg.mapManager.versionHistory.mapperCheckIn.saveSuccess')"
      color="success"
      @select-ok="onClickOkay"
    >
    </dialogWindow>
    <dialogWindow
      ref="detailDialog"
      size="max"
      :detail="detailDialog"
      color="warning"
      @select-ok="onClickOkayAlert"
    >
    </dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import { mapState } from "vuex";
 /* 2020/11/06 203737 Remove unused source
import {UploadFile} from '@/vue-dlb/models'*/
import dialogWindow from '@/vue-dlb/components/NewDialog.vue'
import cfg from '@/vue-caas/config/config.js'

import {
  /* 2020/11/06 203737 Remove unused source
  showSuccessMessage,
  showErrorMessage,*/
  showProgress,
  hideProgress,
  /* 2020/11/06 203737 Remove unused source
  alertSuccess,
  closeAlert*/
} from "@/vue-dlb/utils/sys-util.js";


export default {
  components: {
      DialogDrag,
      dialogWindow
    },
    name: 'edi-uploadfile-dialog',
    /* 2020/10/29 203737 Change prop definitions
    props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd', 'queryList','callby','versionList','reFreshList'],*/
    props:{
      id: String,
      options: Object,
      closeDialog: Function,
      dragStart: Function,
      dragEnd: Function,
      versionList: Object,
      reFreshList: Function
    },
    computed: {
    /* 2020/11/06 203737 Remove unused source
    ...mapState("common", {
      uploadedFile: "uploadedFile"
    }),*/
    ...mapState("mapbuilder", {
      libList: "libList"
    }),
    ...mapState("common", {
      fileContent: "fileContent",
    }),
  },
  data(){
    return {
    selectCodeName: this.$t('lbl.mapBuilder.builderCheckIn.codeCovertingTable'),
    selectCodeId: '',
    fileLoaded: '',
    successDialog: false,
    detailDialog: '',
    mapName: '',
    contenInput: '',
    isValidU: false,
    isValidC: false,
    contentComment: '',
    uploadCheckIn: {
      header: ['MAP_PRCS_NO','MAP_TYPE', 'MAP_NAME', 'MAP_COMT', 'MAP_FILE_NAME', 'MAP_FILE_ID', 'MAP_FILE_SIZE','CODE_CTG_ID','LIB_VER', 'ORA_VER', 'TARGET_FILE_NAME', 'TARGET_FILE_ID'],
      data: [{
        MAP_PRCS_NO: '',
        MAP_TYPE:'',
        MAP_NAME:'',
        MAP_COMT:'',
        MAP_FILE_NAME:'',
        MAP_FILE_ID:'',
        MAP_FILE_SIZE:'',
        CODE_CTG_ID: '',
        LIB_VER: '',
        ORA_VER: '',
        TARGET_FILE_NAME: '',
        TARGET_FILE_ID: '',
        file:null,
      }],
    },
    lockItems:{
      header: ['MAP_KIND','MAP_PRCS_NO','LOCK_YN'],
      data: [{
        MAP_KIND:'',
        MAP_PRCS_NO:'',
        LOCK_YN:''
      }],
    },
    librarySearchItem: {
      header: ['CUST_ID'],
      data: [{
        CUST_ID:'',
      }],
    },
    libraryItem:[
      {text:'Compile library', value:''}
    ],
    versionHistoryItems: {
      header: ['MAP_PRCS_NO'],
      data: [{
        MAP_PRCS_NO: ''
      }]
    },
    libraryVersion:'',
    oracleVersion:'',
    isDlb: false,
    mapNameLoad: '',
  }},
  mounted() {
    setTimeout(() => {
        this.$refs.comRef.focus();
    }, 300);
  },
  created(){
    // console.log(this.options.item.data)
    this.isDlb = cfg.isDlb;
    this.getLibraryVersion();
    this.mapName = this.versionList.MAP_NAME;
    this.mapNameLoad = this.versionList.MAPPER_NAME;
    if (this.versionList.CODE_CTG_ID != null && this.versionList.CODE_CTG_ID != '' ) {
      this.selectCodeName = this.versionList.CODE_CTG_NAME;
      this.selectCodeId = this.versionList.CODE_CTG_ID;
    }
  },
  methods: {
    onVersionChange(libver) {
      for (let i = 0; i < this.libList.length; i++) {
        if (libver === this.libList[i].SITE_CODE) {
          this.oracleVersion = this.libList[i].ORA_VER;
          break;
        }
      }
    },
    getLibraryVersion() {
      this.librarySearchItem.data[0].CUST_ID = $cookies.get('comp-id');
      Store.dispatch("mapbuilder/queryLibraryList", this.librarySearchItem).then(() => {
        for (let i = 0; i < this.libList.length; i++) {
          if(this.isDlb) {
            let item = this.libList[i];
            this.libraryItem.push({
              text: item.SITE_NAME,
              value: item.SITE_CODE
            })
          } else {
            if (this.libList[i].SITE_CODE === 'for_platform') {
              let item = this.libList[i];
              this.libraryItem.push({
                text: item.SITE_NAME,
                value: item.SITE_CODE
              })

              this.libraryItem.shift();
              break;
            }
          }
        }
        this.libraryVersion = this.libraryItem[0].value;
      })
    },
    saveCheckIn () {
      if (this.contenInput.trim() == '' || this.contentComment.trim() == '' || this.libraryVersion == '') {
        if (this.contenInput.trim() == '' && this.contentComment.trim() == ''  && this.libraryVersion == '') {
          this.isValidU = true;
          this.isValidC = true;
          this.detailDialog = this.$t('msg.common.requires',["Mapper Name, Comment, Compile Library"]);
        } else if (this.contenInput.trim() == '' &&  this.libraryVersion == '' ) {
          this.isValidU = true;
          this.isValidC = false;
          this.detailDialog = this.$t('msg.common.require',["Mapper Name, Compile Library"]);
        } else if (this.contentComment.trim() == ''&&  this.libraryVersion == '') {
          this.isValidC = true;
          this.isValidU = false;
          this.detailDialog = this.$t('msg.common.require',["Comment, Compile Library"]);
        } else if (this.contenInput.trim() == '') {
          this.isValidU = true;
          this.isValidC = false;
          this.detailDialog = this.$t('msg.common.require',["Mapper Name"]);
        } else if (this.contentComment.trim() == '') {
          this.isValidC = true;
          this.isValidU = false;
          this.detailDialog = this.$t('msg.common.require',["Comment"]);
        } else if (this.libraryVersion == '') {
          this.isValidC = false;
          this.isValidU = false;
          this.detailDialog = this.$t('msg.common.require',["Compile Library"]);
        }
        this.$refs.detailDialog.dialog = true;
        return;
      }
      let validResult = this.$refs.form.validate();
      if (validResult) {
        console.log("--------- savaData ----------");
          this.uploadCheckIn.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
          this.uploadCheckIn.data[0].MAP_TYPE = 'MAPP';
          this.uploadCheckIn.data[0].MAP_NAME = this.versionList.MAP_NAME;   // SubDirecotry Name
          this.uploadCheckIn.data[0].MAP_COMT = this.contentComment.trim();
          this.uploadCheckIn.data[0].MAP_FILE_NAME = this.contenInput;   // TBD - by April. Please check here too.
          this.uploadCheckIn.data[0].MAP_FILE_ID = this.fileLoaded.FILE_ID;   // TBD - by April. Please set scanner file id saved on a scrren.
          this.uploadCheckIn.data[0].MAP_FILE_SIZE = this.fileLoaded.USR_FILE_SIZE;
          // CLV-Change Load CODE_CTG_ID from Select Code Table
          this.uploadCheckIn.data[0].CODE_CTG_ID = this.selectCodeId;  // TBD - by April. Please change here for CodeTable
          if (this.isDlb) {
            this.uploadCheckIn.data[0].LIB_VER = this.libraryVersion;
          } else {
            this.uploadCheckIn.data[0].LIB_VER = 'for_platform'
          }
          this.uploadCheckIn.data[0].ORA_VER = this.oracleVersion;
          this.uploadCheckIn.data[0].TARGET_FILE_NAME = '';
          this.uploadCheckIn.data[0].TARGET_FILE_ID = '';
          this.uploadCheckIn.data[0].file = this.fileContent;
          // Upload Flat File Data
          showProgress();
          Store.dispatch("map/checkInMap", this.uploadCheckIn).then(() => {
            console.log("--------- Finished to process ----------");
            /*
              2021/01/15 203665 workflow issue 21  send only edit Data to JSON
            */
            if(this.mapNameLoad !== this.contenInput){
              let editedData = {
                MAPPER_NAME : this.contenInput,
                MAP_PRCS_NO: this.versionList.MAP_PRCS_NO
              };
              this.sendActivate(this.uploadCheckIn.data[0].MAP_PRCS_NO, 'MAP', editedData);
            }
            hideProgress();
            this.versionHistoryItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
            Store.dispatch("map/queryMapperHistoryList", this.versionHistoryItems).then(() => {
              console.log("--------- Finished to process ----------");
            });
            this.$refs.successDialog.dialog = true;
          });
      }
      return validResult;
    },
    sendActivate(comId, comTp,info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info
      };
      this.$store.dispatch('updateProcessInfo', params).then((res) => {
        console.log(res);
      }).catch((err) => {
        console.log('error when send update to kafka')
      });
    },
    onClickOkayAlert(){
       let self = this;
      setTimeout(() => {
        self.$refs.comRef.focus();
      }, 600);
    },
    onClickOkay(){
      this.onClickOkaySave();
      this.removeDialog({})
    },
    onClickOkaySave (){
        this.lockItems.data[0].MAP_KIND = 'MAPP';
        this.lockItems.data[0].MAP_PRCS_NO = this.versionList.MAP_PRCS_NO;
        this.lockItems.data[0].LOCK_YN = 'N';

        Store.dispatch("map/updateLock", this.lockItems).then(() => {
          console.log("--------- Finished to process CHECKOUT ----------");
          this.reFreshList();
        });
    },
    /* 2020/10/28 203737 Remove unused source
    clickBrowse() {
      this.$refs.edifile.click();
    },*/
    onFileChanged(e) {
      this.contenInput = e.target.files[0].name;
    },
    removeDialog (dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog (obj) {
      this.dragStart(obj);
    },
    dialogDragEnd (obj) {
        this.dragEnd(obj);
    },
    openCodeTableDialog(){
      this.$emit('openCodeTableDialog');
    },
    updateSelectCodeTitle(item){
      this.selectCodeName = item.CODE_CTG_NAME;
      this.selectCodeId = item.CODE_CTG_ID;
    },
    openLoadFilePop(data){
      let {mode, filetype} = data;
      if (mode == 'Load') {
        let callback = (row) => {
          this.codeTableName = this.$t('btn.mapBuilder.selectCodeTable');
          Store.dispatch("common/viewFileData", row.FILE_ID).then(() => {
            if (filetype == 'inputMap') {
              this.$refs.input_data.value= null;
              if(typeof this.fileContent === 'object'){
                this.inputFileContent = JSON.stringify(this.fileContent, null, '\t');
              }else{
                this.inputFileContent = this.fileContent.toString();
              }
              this.fileID = row.FILE_ID;
              this.inputFileName = row.USR_FILE_NAME;
              this.inputFileNameSave = row.USR_FILE_NAME;
              this.inputFileSize = row.USR_FILE_SIZE;
              this.inputFileExtension = row.USR_FILE_TYPE;
              this.inputFolderId = row.FOLD_ID;
              this.lastFoldIdBiz = row.FOLD_ID;
            } else if (filetype == 'mapper') {
              // this.$refs.mapper_data.value= null;
              if(typeof this.fileContent === 'object'){
                this.mapperFileContent = JSON.stringify(this.fileContent, null, '\t');
              }else{
                this.mapperFileContent = this.fileContent.toString();
              }
              this.contenInput =  row.USR_FILE_NAME;
              this.mapperFileID = row.FILE_ID;
              this.mapperFileName = row.USR_FILE_NAME;
              this.mapperFileNameSave = row.USR_FILE_NAME;
              this.mapperFileSize = row.USR_FILE_SIZE;
              this.mapperFileExtension = row.USR_FILE_TYPE;
              this.mapperFolderId = row.FOLD_ID;
              this.resultField = '';
              this.buildResultMSG ='';
              this.isSaved = true;
              this.isDisableChkMap = true;
              this.lastFoldIdMapper = row.FOLD_ID;
            }
          });
        };
        // this.$emit('openLoadFile', {mode : 'Load',filetype:filetype,lastFoldId: this.lastFoldId, callback});
        this.$emit('openLoadFile', {mode : 'Load',filetype: filetype,lastFoldIdBiz: this.lastFoldIdBiz,lastFoldIdMapper:this.lastFoldIdMapper, callback});
        //this.$emit('openLoadFile', {mode : 'Load', callback});
      }
    },
  },
}
</script>

<style>
.add-map-layout-dialog {
    width: 888px !important;
  }

  .theme--dark .add-map-layout-dialog .dialog-body, .theme--dark .add-map-layout-dialog .dialog-body .v-sheet {
    background-color: #292c35;
    border-left: none !important;
  }

  .add-map-layout-dialog .theme--dark .v-text-field.data-table-select-box.communication-select-box.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
    background: #3B3E49;
  }

  .theme--dark .add-map-layout-dialog .v-text-field--outlined.flatfile-layout-selectbox fieldset, .v-text-field--outlined.text-field-flatfile-layout fieldset {
    border-color: #3B3E49;
  }

  .add-map-layout-dialog  .inline-block-component {
    display: flex;
  }

  .add-map-layout-dialog .csv-file-textfield, .add-map-layout-dialog .flatfile-textfield {
    width: calc(100% - 70px);
    padding-right: 12px;
  }
   .add-map-layout-dialog .csv-file-textfield {
    width: 100%;
    padding-right: 12px;
  }
  .add-map-layout-dialog .map-name-textfield{
    padding-right: 2px;
  }

  .add-map-layout-dialog .btn-active {
    width: 70px;
    margin-top: -2px;
  }

  .add-map-layout-dialog .dialog-header{
      background-color: #253C51;
      height: 60px !important;
  }
  .map-text-field{
    padding-right: 0px;
  }
  /* .add-map-layout-dialog span {
    font-size: 14px;
    line-height: 19px;
    color: #12083F;
    font-weight: bold;
  } */

  .add-map-layout-dialog .v-btn span {
    font-weight: normal;
  }

  .add-map-layout-dialog .theme--light.v-text-field--outlined.data-table-filter-text-field.text-field-flatfile-layout fieldset {
    /* border: 1px solid #CEDEFF; */
    border-radius: 3px;
  }

  .add-map-layout-dialog .flatfile-layout-selectbox.v-text-field--outlined fieldset {
    /* border: 1px solid #CEDEFF; */
    border-radius: 3px;
  }

  .theme--light .add-map-layout-dialog .v-text-field--outlined.readonly-textfield fieldset {
    background: #EEEEEE;
  }

  .theme--dark .add-map-layout-dialog .v-text-field--outlined.readonly-textfield fieldset {
    background: #3B3E49;
  }

  /* .theme--dark .add-map-layout-dialog .v-input input {
    color: #bbbbbb !important;
  } */

  .theme--dark .add-map-layout-dialog .v-input.readonly-textfield input {
    color: #bbbbbb !important;
  }

  .add-map-layout-dialog .flatfile-layout-selectbox.v-text-field--outlined i {
    color: #CEDEFF;
  }

  .add-map-layout-dialog .v-text-field--outlined.flatfile-layout-selectbox fieldset, .v-text-field--outlined.text-field-flatfile-layout fieldset {
    top: -8px;
  }

  /* .theme--dark .add-map-layout-dialog form {
    border: none;
    background-color: #292C35 !important;
  }

  .theme--dark .add-map-layout-dialog form span.field-label {
    color: #bbbbbb;
  } */

  /* .add-map-layout-dialog .field-col {
    padding-right: 0px;
    padding-left: 20px;
    padding-top: 12px;
    line-height:30px;
  } */

  /* .add-map-layout-dialog .required-col {
    padding-left: 0px;
  } */
   /* .add-map-layout-dialog .not-required-col {
    padding-left: 21px;
  } */

  .add-map-layout-dialog .button-col {
    padding-bottom: 10px;
  }

  .add-map-layout-dialog .v-text-field input, .add-map-layout-dialog .v-text-field input::placeholder {
    font-size: 14px !important;
    font-weight: normal;
  }
  .data-table-select-box.custom-selectbox.map-name-selectbox .v-input__control{
  border-radius: 3px;
  border: 1px solid #CEDEFF;
  background: #FFFFFF;
}
.btn-form-control .status-rollback-button.map-dialog-btn, .btn-form-control .delete-customer-edi-list-button.map-dialog-btn{
  width: 100px !important;
}
.add-map-layout-dialog .v-icon.notranslate.fas.fa-asterisk.theme--light{
  width: 17px;
}

.theme--dark .add-map-layout-dialog .data-table-select-box .v-input__control .v-input__slot .v-select__selections .v-select__selection, .theme--dark .add-map-layout-dialog .data-table-select-box .v-input__control .v-input__slot .v-input__append-inner i {
  color: #bbbbbb !important;
  font-weight: normal;
}
/* .add-map-layout-dialog span.to-text{
  margin-right:10px;
  margin-left: 10px;
  line-height:30px;
} */
.add-map-layout-dialog .map-type-col{
  display:flex;
  padding-left: 2px;
}
.add-map-layout-dialog .flatfile-textfield.scanner-textfield{
  padding-right: 0px
}
.scanner-load-btn{
  margin-left:10px;
}
.theme--dark .map-text-field .edi-mes-list .v-input__control .v-input__slot{
  background-color:#3b3e49;
}
.theme--light .map-text-field .edi-mes-list .v-input__control .v-input__slot{
  border: 1px solid #cedeff;
  border-radius: 4px;
}
.theme--light .map-text-field .edi-mes-list .v-input__control .v-input__slot i{
  color:#cedeff;
}
/* .add-map-layout-dialog span.edi-version-text{
   position: absolute;
   left: 41px;
   line-height: 30px;
} */
/* .add-map-layout-dialog.custom-add-map-layout-dialog .v-input__control{
  display:block;
} */
.add-map-layout-dialog.custom-add-map-layout-dialog .v-text-field__details{
  padding-left: 3px !important;
  margin-top: 4px;
}
.add-map-layout-dialog.custom-add-map-layout-dialog .v-text-field__details .v-messages{
  font-size:10px
}
.add-map-layout-dialog.custom-add-map-layout-dialog .edi-version-col{
  padding-left:26px !important;
}
.customer-add-map-layout{
  margin-top: -20px !important;
  margin-bottom: -18px !important;
}
</style>
